import { render, staticRenderFns } from "./ganti-rugi.vue?vue&type=template&id=52a8cb98"
import script from "./ganti-rugi.vue?vue&type=script&lang=js"
export * from "./ganti-rugi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports